import { UntitledIcon } from '@faceup/icons'
import { usXClose } from '@faceup/icons/usXClose'
import { Typography, useUiBaseConfig } from '@faceup/ui-base'
import type { ReactNode } from 'react'
import { defineMessages, FormattedMessage } from '../../../TypedIntl'

const messages = defineMessages({
  disabledTitle: 'FollowUp.cases.disabled.title',
  disabledDescription: 'FollowUp.cases.disabled.description',
})

export const PageNotAvailable = () => (
  <div className='flex flex-col gap-6 items-center justify-center min-h-[60vh]'>
    <CircleIcon icon={<UntitledIcon icon={usXClose} size='40px' color='white' />} />
    <Typography.Title>
      <FormattedMessage {...messages.disabledTitle} />
    </Typography.Title>
    <Typography.Text>
      <FormattedMessage {...messages.disabledDescription} />
    </Typography.Text>
  </div>
)

const CircleIcon = ({ icon }: { icon: ReactNode }) => {
  const { token } = useUiBaseConfig()
  return (
    <div
      className='flex justify-center items-center w-[66px] h-[66px] rounded-full'
      style={{
        background: token.colorPrimary,
      }}
    >
      {icon}
    </div>
  )
}
